import { Injectable } from '@angular/core';
import { Exportable } from '../model/exports/exportable';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';

@Injectable()
export class ExportService {

    constructor() {
    }

    public exportData<T>(elements: any[], exportable: Exportable<T>, title: string): void {
        if (elements.length) {
            const exportData = exportable.getExportData(elements);
            const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

            this.addStyleDataToWorksheet<T>(elements, exportable, worksheet);

            const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });
            this.saveAsExcelFile(excelBuffer, title + '.xls');
        }
    }

    // add style info to sheet
    private addStyleDataToWorksheet<T>(elements: any[], exportable: Exportable<T>, worksheet: XLSX.WorkSheet) {

        // add style info for the columns (width,height,etc)
        exportable.addStyleData(worksheet);

        // add style info for the specific cells (font,alignment,etc)
        const cellLabels = exportable.getCellIdentifiers(elements);

        for (const cellLabel of cellLabels.regularCelsToStyle) {
            worksheet[cellLabel].s = { alignment: { wrapText: false, vertical: 'center', horizontal: 'center' } };
        }

        for (const cellLabel of cellLabels.headerCelsToStyle) {
            worksheet[cellLabel].s = { alignment: { wrapText: false, vertical: 'center', horizontal: 'center' }, font: { bold: true } };
        }
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: FileSaver.EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName);
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/export.service.ts